module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.data.class, 'nested-group']
  }, _vm._l((_vm.data.fields), function(field, fieldKey) {
    return _c('APPROVAL_' + field.fieldType, {
      key: fieldKey,
      tag: "component",
      attrs: {
        "data": field,
        "footnotes": _vm.footnotes
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-914b2598"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/NESTED_GROUP.vue
// module id = 708
// module chunks = 0